// @ts-strict-ignore
import React from 'react'
import Image from '../../imgix-img'

interface Item {
  altValue: string
  url: string
}

interface FeaturedInModuleDetailsProps {
  name: string
  jsonBody: {
    reasons: Item[]
  }
  showHeader: boolean
}

const FeatureInModule = ({ jsonBody, name, showHeader }: FeaturedInModuleDetailsProps) => {
  try {
    return (
      <div className='featured-in-module' id={name}>
        {showHeader && <h3 className='featured-in-module__heading'>We’ve been featured in</h3>}
        <div className='featured-in-module__container'>
          <div className='featured-in-module__container__banner'>
            {jsonBody.reasons.map(({ url, altValue }) => {
              return (
                <Image
                  className='featured-in-module__container__img'
                  key={altValue}
                  src={url}
                  alt={altValue}
                />
              )
            })}
            {jsonBody.reasons.map(({ url, altValue }) => {
              return (
                <Image
                  className='featured-in-module__container__img-desktop'
                  key={altValue}
                  src={url}
                  alt={altValue}
                />
              )
            })}
          </div>
        </div>
      </div>
    )
  } catch (error) {
    return <></>
  }
}

export default FeatureInModule
